export const version = "hdnode/5.6.0";
//# sourceMappingURL=_version.js.map